// // import { motion } from "framer-motion";
// // import {
// //   Factory,
// //   Briefcase,
// //   TrendingUp,
// //   Cpu,
// //   Leaf,
// // } from "lucide-react";

// // const pillars = [
// //   {
// //     number: "01",
// //     icon: Factory,
// //     title: "Make in India",
// //     subtitle: "Towards an Atmanirbhar Bharat",
// //     desc: "Strengthening domestic manufacturing capabilities and building a self-reliant industrial ecosystem that powers India's growth story.",
// //     image:
// //       "https://images.pexels.com/photos/32048356/pexels-photo-32048356.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=500&w=700",
// //   },
// //   {
// //     number: "02",
// //     icon: Briefcase,
// //     title: "Ease of Doing Business",
// //     subtitle: "Enhancing Investments & Capital Formation",
// //     desc: "Simplifying regulations, reducing compliance burden, and creating an investment-friendly climate for domestic and foreign capital.",
// //     image:
// //       "https://images.pexels.com/photos/7580648/pexels-photo-7580648.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=500&w=700",
// //   },
// //   {
// //     number: "03",
// //     icon: TrendingUp,
// //     title: "MSME Growth",
// //     subtitle: "Driving Employment and Exports",
// //     desc: "Empowering micro, small and medium enterprises as engines of job creation, innovation, and export competitiveness.",
// //     image:
// //       "https://images.pexels.com/photos/31336008/pexels-photo-31336008.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=500&w=700",
// //   },
// //   {
// //     number: "04",
// //     icon: Cpu,
// //     title: "Digital Economy",
// //     subtitle: "Making Future Ready Developed India",
// //     desc: "Accelerating digital transformation across sectors to build a tech-enabled, knowledge-driven, and globally competitive economy.",
// //     image:
// //       "https://images.pexels.com/photos/7581114/pexels-photo-7581114.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=500&w=700",
// //   },
// //   {
// //     number: "05",
// //     icon: Leaf,
// //     title: "Sustainability & Environment",
// //     subtitle: "Making it better for future generations",
// //     desc: "Championing green growth, climate action, and sustainable business practices that protect our planet for generations to come.",
// //     image:
// //       "https://images.pexels.com/photos/12225080/pexels-photo-12225080.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=500&w=700",
// //   },
// // ];

// // export default function GrowthPillars() {
// //   return (
// //     <section id="pillars" className="relative bg-[#FAF7F2] py-20 md:py-4">
// //       <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
// //         <div className="mb-12 text-center md:mb-16">
// //           {/* <motion.span
// //             initial={{ opacity: 0 }}
// //             whileInView={{ opacity: 1 }}
// //             viewport={{ once: true }}
// //             className="mb-3 inline-block text-xs font-bold tracking-[0.2em] text-[#DA2128] uppercase"
// //           >
// //             Viksit Bharat 2047
// //           </motion.span> */}
// //           <motion.h2
// //             initial={{ opacity: 0, y: 20 }}
// //             whileInView={{ opacity: 1, y: 0 }}
// //             viewport={{ once: true }}
// //             className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl md:text-5xl"
// //           >
// //             Growth Pillars
// //           </motion.h2>
// //           <div className="mx-auto mt-4 accent-bar" />
// //           <motion.p
// //             initial={{ opacity: 0, y: 15 }}
// //             whileInView={{ opacity: 1, y: 0 }}
// //             viewport={{ once: true }}
// //             className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-gray-600 sm:text-base"
// //           >
// //             The engagements at ASSOCHAM are driven by its five growth pillars,
// //             aligned with the Hon'ble Prime Minister's vision of Viksit Bharat
// //             2047 — focused on building a self-reliant, business-competitive,
// //             digitally empowered, and developed Indian economy.
// //           </motion.p>
// //         </div>

// //         <div className="space-y-6">
// //           {pillars.map((pillar, i) => {
// //             const isEven = i % 2 === 0;
// //             return (
// //               <motion.div
// //                 key={pillar.number}
// //                 initial={{ opacity: 0, y: 40 }}
// //                 whileInView={{ opacity: 1, y: 0 }}
// //                 viewport={{ once: true, margin: "-60px" }}
// //                 transition={{ duration: 0.6, delay: i * 0.05 }}
// //                 className={`pillar-card group grid overflow-hidden rounded-3xl bg-white shadow-lg shadow-black/5 transition-shadow hover:shadow-xl md:grid-cols-2 ${
// //                   !isEven ? "md:[direction:rtl]" : ""
// //                 }`}
// //               >
// //                 {/* Image */}
// //                 <div className="img-reveal relative h-52 overflow-hidden md:h-auto md:min-h-[260px]">
// //                   <img
// //                     src={pillar.image}
// //                     alt={pillar.title}
// //                     className="h-full w-full object-cover"
// //                   />
// //                   <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent md:bg-gradient-to-r md:from-transparent md:to-black/10" />
// //                   <span className="absolute left-5 top-5 flex h-12 w-12 items-center justify-center rounded-xl bg-[#DA2128] text-sm font-bold text-white shadow-lg">
// //                     {pillar.number}
// //                   </span>
// //                 </div>

// //                 {/* Content */}
// //                 <div className="flex flex-col justify-center p-6 sm:p-8 md:p-10 md:[direction:ltr]">
// //                   <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-[#DA2128]/10 text-[#DA2128] transition-all duration-300 group-hover:bg-[#DA2128] group-hover:text-white group-hover:scale-110">
// //                     <pillar.icon size={24} />
// //                   </div>
// //                   <h3 className="text-xl font-bold text-gray-900 sm:text-2xl">
// //                     {pillar.title}
// //                   </h3>
// //                   <p className="mt-1 text-sm font-semibold text-[#DA2128]">
// //                     {pillar.subtitle}
// //                   </p>
// //                   <p className="mt-3 text-sm leading-relaxed text-gray-600 sm:text-base">
// //                     {pillar.desc}
// //                   </p>
// //                 </div>
// //               </motion.div>
// //             );
// //           })}
// //         </div>
// //       </div>
// //     </section>
// //   );
// // }







// // new code 




// import { motion } from "framer-motion";
// import {
//   Factory,
//   Briefcase,
//   TrendingUp,
//   Cpu,
//   Leaf,
// } from "lucide-react";

// const pillars = [
//   {
//     number: "01",
//     icon: Factory,
//     title: "Make in India",
//     subtitle: "Towards an Atmanirbhar Bharat",
//     desc: "Strengthening domestic manufacturing capabilities and building a self-reliant industrial ecosystem that powers India's growth story.",
//     image:
//       "https://images.pexels.com/photos/32048356/pexels-photo-32048356.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=500&w=700",
//   },
//   {
//     number: "02",
//     icon: Briefcase,
//     title: "Ease of Doing Business",
//     subtitle: "Enhancing Investments & Capital Formation",
//     desc: "Simplifying regulations, reducing compliance burden, and creating an investment-friendly climate for domestic and foreign capital.",
//     image:
//       "https://images.pexels.com/photos/7580648/pexels-photo-7580648.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=500&w=700",
//   },
//   {
//     number: "03",
//     icon: TrendingUp,
//     title: "MSME Growth",
//     subtitle: "Driving Employment and Exports",
//     desc: "Empowering micro, small and medium enterprises as engines of job creation, innovation, and export competitiveness.",
//     image:
//       "https://images.pexels.com/photos/31336008/pexels-photo-31336008.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=500&w=700",
//   },
//   {
//     number: "04",
//     icon: Cpu,
//     title: "Digital Economy",
//     subtitle: "Making Future Ready Developed India",
//     desc: "Accelerating digital transformation across sectors to build a tech-enabled, knowledge-driven, and globally competitive economy.",
//     image:
//       "https://images.pexels.com/photos/7581114/pexels-photo-7581114.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=500&w=700",
//   },
//   {
//     number: "05",
//     icon: Leaf,
//     title: "Sustainability and Environment",
//     subtitle: "Making it better for future generations",
//     desc: "Championing green growth, climate action, and sustainable business practices that protect our planet for generations to come.",
//     image:
//       "https://images.pexels.com/photos/12225080/pexels-photo-12225080.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=500&w=700",
//   },
// ];

// export default function GrowthPillars() {
//   return (
//     <section id="pillars" className="relative bg-[#FAF7F2] py-16 md:py-20">
//       <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
//         {/* Header */}
//         <div className="mb-10 text-center md:mb-12">
//           <motion.span
//             initial={{ opacity: 0, y: 10 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             className="mb-3 inline-block rounded-full border border-[#DA2128]/20 bg-[#DA2128]/5 px-4 py-1 text-[10px] font-bold tracking-[0.25em] text-[#DA2128] uppercase"
//           >
//             Viksit Bharat 2047
//           </motion.span>
//           <motion.h2
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.5 }}
//             className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl md:text-[2.75rem]"
//           >
//             Growth Pillars
//           </motion.h2>
//           <motion.div
//             initial={{ scaleX: 0 }}
//             whileInView={{ scaleX: 1 }}
//             viewport={{ once: true }}
//             transition={{ delay: 0.3, duration: 0.5 }}
//             className="mx-auto mt-3 h-1 w-16 rounded-full bg-gradient-to-r from-[#DA2128] to-amber-500"
//           />
//           <motion.p
//             initial={{ opacity: 0, y: 15 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.5, delay: 0.15 }}
//             className="mx-auto mt-4 max-w-3xl text-sm leading-relaxed text-gray-600 sm:text-[15px]"
//           >
//             The engagements at ASSOCHAM, India's Apex Chamber of Commerce, are
//             driven by its five growth pillars, aligned with the Hon'ble Prime
//             Minister's vision of Viksit Bharat 2047. These pillars are focused on
//             building a self-reliant, business-competitive, digitally empowered,
//             and developed Indian economy.
//           </motion.p>
//         </div>

//         {/* Pillar cards — zig-zag */}
//         <div className="space-y-3 sm:space-y-4">
//           {pillars.map((pillar, i) => {
//             const isEven = i % 2 === 0;

//             return (
//               <motion.div
//                 key={pillar.number}
//                 initial={{
//                   opacity: 0,
//                   x: isEven ? -60 : 60,
//                   y: 20,
//                 }}
//                 whileInView={{
//                   opacity: 1,
//                   x: 0,
//                   y: 0,
//                 }}
//                 viewport={{ once: true, margin: "-50px" }}
//                 transition={{
//                   duration: 0.65,
//                   delay: i * 0.08,
//                   ease: [0.22, 1, 0.36, 1],
//                 }}
//                 className="group grid overflow-hidden rounded-2xl bg-white shadow-md shadow-black/5 transition-all duration-500 hover:shadow-xl hover:shadow-black/10 md:grid-cols-2"
//               >
//                 {/* IMAGE side */}
//                 <div
//                   className={`relative h-24 overflow-hidden sm:h-28 md:min-h-[220px] ${
//                     !isEven ? "md:order-2" : ""
//                   }`}
//                 >
//                   <motion.img
//                     initial={{ scale: 1.15 }}
//                     whileInView={{ scale: 1 }}
//                     viewport={{ once: true }}
//                     transition={{ duration: 1.2, ease: "easeOut" }}
//                     src={pillar.image}
//                     alt={pillar.title}
//                     className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
//                   />
//                   <div
//                     className={`absolute inset-0 ${
//                       isEven
//                         ? "bg-gradient-to-t from-black/50 via-black/10 to-transparent md:bg-gradient-to-r md:from-black/20 md:via-transparent md:to-transparent"
//                         : "bg-gradient-to-t from-black/50 via-black/10 to-transparent md:bg-gradient-to-l md:from-black/20 md:via-transparent md:to-transparent"
//                     }`}
//                   />

//                   {/* Number badge */}
//                   <motion.span
//                     initial={{ scale: 0, rotate: -20 }}
//                     whileInView={{ scale: 1, rotate: 0 }}
//                     viewport={{ once: true }}
//                     transition={{
//                       duration: 0.5,
//                       delay: i * 0.08 + 0.3,
//                       type: "spring",
//                       bounce: 0.5,
//                     }}
//                     className="absolute left-3 top-3 flex h-8 w-8 items-center justify-center rounded-lg bg-[#DA2128] text-xs font-bold text-white shadow-lg sm:h-9 sm:w-9 sm:text-sm"
//                   >
//                     {pillar.number}
//                   </motion.span>

//                   {/* Decorative corner flourish */}
//                   <div className="absolute bottom-2 right-2 flex items-center gap-1.5 rounded-full bg-white/90 px-2.5 py-0.5 text-[9px] font-bold tracking-wider text-[#DA2128] uppercase backdrop-blur-sm sm:text-[10px]">
//                     Pillar {Number(pillar.number)}
//                   </div>
//                 </div>

//                 {/* CONTENT side */}
//                 <div
//                   className={`relative flex flex-col justify-center p-3 sm:p-4 md:p-4 lg:p-5 ${
//                     !isEven ? "md:order-1 md:text-right" : ""
//                   }`}
//                 >
//                   <div
//                     className={`flex items-start gap-3 ${
//                       !isEven ? "md:flex-row-reverse md:text-right" : ""
//                     }`}
//                   >
//                     {/* Icon */}
//                     <motion.div
//                       initial={{ scale: 0, rotate: -15 }}
//                       whileInView={{ scale: 1, rotate: 0 }}
//                       viewport={{ once: true }}
//                       transition={{
//                         duration: 0.5,
//                         delay: i * 0.08 + 0.2,
//                         type: "spring",
//                         bounce: 0.6,
//                       }}
//                       className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#DA2128]/10 text-[#DA2128] transition-all duration-300 group-hover:bg-[#DA2128] group-hover:text-white group-hover:scale-110 group-hover:rotate-6 sm:h-10 sm:w-10"
//                     >
//                       <pillar.icon size={18} strokeWidth={2.2} />
//                     </motion.div>

//                     <div className="flex-1 min-w-0">
//                       <h3 className="text-base font-bold leading-tight text-gray-900 sm:text-lg">
//                         {pillar.title}
//                       </h3>
//                       <p className="mt-0.5 text-[11px] font-semibold text-[#DA2128] sm:text-xs">
//                         {pillar.subtitle}
//                       </p>
//                       <p className="mt-1.5 text-xs leading-relaxed text-gray-600 sm:text-[13px]">
//                         {pillar.desc}
//                       </p>

//                       {/* small divider */}
//                       <div
//                         className={`mt-2.5 h-[2px] w-8 rounded-full bg-[#DA2128] ${
//                           !isEven ? "md:ml-auto" : ""
//                         }`}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </motion.div>
//             );
//           })}
//         </div>
//       </div>
//     </section>
//   );
// }





// new new code 






import { motion } from "framer-motion";
import {
  Factory,
  Briefcase,
  TrendingUp,
  Cpu,
  Leaf,
} from "lucide-react";

const pillars = [
  {
    number: "01",
    icon: Factory,
    title: "Make in India",
    subtitle: "Towards an Atmanirbhar Bharat",
    desc: "Strengthening domestic manufacturing capabilities and building a self-reliant industrial ecosystem that powers India's growth story.",
    image:
      "https://images.pexels.com/photos/32048356/pexels-photo-32048356.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=500&w=700",
  },
  {
    number: "02",
    icon: Briefcase,
    title: "Ease of Doing Business",
    subtitle: "Enhancing Investments & Capital Formation",
    desc: "Simplifying regulations, reducing compliance burden, and creating an investment-friendly climate for domestic and foreign capital.",
    image:
      "https://images.pexels.com/photos/7580648/pexels-photo-7580648.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=500&w=700",
  },
  {
    number: "03",
    icon: TrendingUp,
    title: "MSME Growth",
    subtitle: "Driving Employment and Exports",
    desc: "Empowering micro, small and medium enterprises as engines of job creation, innovation, and export competitiveness.",
    image:
      "https://images.pexels.com/photos/31336008/pexels-photo-31336008.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=500&w=700",
  },
  {
    number: "04",
    icon: Cpu,
    title: "Digital Economy",
    subtitle: "Making Future Ready Developed India",
    desc: "Accelerating digital transformation across sectors to build a tech-enabled, knowledge-driven, and globally competitive economy.",
    image:
      "https://images.pexels.com/photos/7581114/pexels-photo-7581114.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=500&w=700",
  },
  {
    number: "05",
    icon: Leaf,
    title: "Sustainability and Environment",
    subtitle: "Making it better for future generations",
    desc: "Championing green growth, climate action, and sustainable business practices that protect our planet for generations to come.",
    image:
      "https://images.pexels.com/photos/12225080/pexels-photo-12225080.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=500&w=700",
  },
];

/* ----- Abstract animated eclipse / orbit background ----- */
function EclipseBackground() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {/* Soft radial vignette wash */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse 80% 60% at 50% 40%, rgba(218,33,40,0.04) 0%, transparent 70%), radial-gradient(ellipse 60% 50% at 20% 80%, rgba(245,158,11,0.04) 0%, transparent 70%)",
        }}
      />

      {/* Large rotating eclipse — top left */}
      <motion.div
        className="absolute -left-32 -top-32 h-[520px] w-[520px]"
        animate={{ rotate: 360 }}
        transition={{ duration: 80, repeat: Infinity, ease: "linear" }}
      >
        <div
          className="absolute inset-0 rounded-full border border-[#DA2128]/10"
          style={{
            background:
              "conic-gradient(from 0deg, transparent 0deg, rgba(218,33,40,0.06) 60deg, transparent 120deg, rgba(218,33,40,0.04) 240deg, transparent 300deg)",
          }}
        />
        <div className="absolute inset-10 rounded-full border border-dashed border-[#DA2128]/10" />
        <div className="absolute inset-20 rounded-full border border-[#DA2128]/5" />
      </motion.div>

      {/* Counter-rotating eclipse — bottom right */}
      <motion.div
        className="absolute -right-40 -bottom-40 h-[640px] w-[640px]"
        animate={{ rotate: -360 }}
        transition={{ duration: 100, repeat: Infinity, ease: "linear" }}
      >
        <div
          className="absolute inset-0 rounded-full"
          style={{
            background:
              "conic-gradient(from 180deg, transparent 0deg, rgba(245,158,11,0.07) 90deg, transparent 180deg, rgba(218,33,40,0.05) 270deg, transparent 360deg)",
          }}
        />
        <div className="absolute inset-16 rounded-full border border-dashed border-amber-400/10" />
        <div className="absolute inset-28 rounded-full border border-[#DA2128]/5" />
      </motion.div>

      {/* Slow counter-rotating ring — middle top */}
      <motion.div
        className="absolute left-1/2 -top-24 h-80 w-80 -translate-x-1/2"
        animate={{ rotate: -360 }}
        transition={{ duration: 60, repeat: Infinity, ease: "linear" }}
      >
        <div className="absolute inset-0 rounded-full border border-[#DA2128]/10" />
        <div className="absolute inset-6 rounded-full border border-dashed border-amber-400/10" />
      </motion.div>

      {/* Orbiting dot — top left orbit */}
      <motion.div
        className="absolute -left-32 -top-32 h-[520px] w-[520px]"
        animate={{ rotate: 360 }}
        transition={{ duration: 80, repeat: Infinity, ease: "linear" }}
      >
        <motion.div
          className="absolute left-1/2 top-0 h-3 w-3 -translate-x-1/2 rounded-full bg-[#DA2128] shadow-[0_0_14px_2px_rgba(218,33,40,0.45)]"
          animate={{ scale: [1, 1.6, 1], opacity: [0.8, 1, 0.8] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        />
      </motion.div>

      {/* Orbiting dot — bottom right orbit */}
      <motion.div
        className="absolute -right-40 -bottom-40 h-[640px] w-[640px]"
        animate={{ rotate: -360 }}
        transition={{ duration: 100, repeat: Infinity, ease: "linear" }}
      >
        <motion.div
          className="absolute left-0 top-1/2 h-2.5 w-2.5 -translate-y-1/2 rounded-full bg-amber-500 shadow-[0_0_12px_2px_rgba(245,158,11,0.5)]"
          animate={{ scale: [1, 1.8, 1], opacity: [0.7, 1, 0.7] }}
          transition={{ duration: 4, repeat: Infinity, ease: "easeInOut", delay: 1 }}
        />
      </motion.div>

      {/* Floating soft eclipse blobs (layered ellipses) */}
      <motion.div
        className="absolute left-[10%] top-[30%] h-48 w-64 rounded-full bg-[#DA2128]/[0.04] blur-3xl"
        animate={{ x: [0, 30, 0], y: [0, -20, 0] }}
        transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute right-[8%] top-[55%] h-56 w-72 rounded-full bg-amber-400/[0.05] blur-3xl"
        animate={{ x: [0, -25, 0], y: [0, 25, 0] }}
        transition={{ duration: 16, repeat: Infinity, ease: "easeInOut", delay: 2 }}
      />
      <motion.div
        className="absolute left-[40%] bottom-[10%] h-40 w-56 rounded-full bg-[#DA2128]/[0.04] blur-3xl"
        animate={{ x: [0, 20, -20, 0], y: [0, -15, 10, 0] }}
        transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* Thin SVG ring grid accents */}
      <svg
        className="absolute inset-0 h-full w-full opacity-20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <radialGradient id="eclipseFade" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#DA2128" stopOpacity="0.15" />
            <stop offset="100%" stopColor="#DA2128" stopOpacity="0" />
          </radialGradient>
        </defs>
        {/* Decorative arcs */}
        <motion.circle
          cx="15%"
          cy="20%"
          r="120"
          fill="none"
          stroke="#DA2128"
          strokeWidth="0.5"
          strokeOpacity="0.15"
          strokeDasharray="1 5"
          initial={{ rotate: 0 }}
          animate={{ rotate: 360 }}
          transition={{ duration: 50, repeat: Infinity, ease: "linear" }}
          style={{ transformOrigin: "15% 20%" }}
        />
        <motion.circle
          cx="85%"
          cy="75%"
          r="160"
          fill="none"
          stroke="#f59e0b"
          strokeWidth="0.5"
          strokeOpacity="0.18"
          strokeDasharray="2 6"
          initial={{ rotate: 0 }}
          animate={{ rotate: -360 }}
          transition={{ duration: 70, repeat: Infinity, ease: "linear" }}
          style={{ transformOrigin: "85% 75%" }}
        />
      </svg>

      {/* Subtle dot pattern for depth */}
      <div
        className="absolute inset-0 opacity-[0.025]"
        style={{
          backgroundImage: "radial-gradient(#000 1px, transparent 1px)",
          backgroundSize: "24px 24px",
        }}
      />
    </div>
  );
}

export default function GrowthPillars() {
  return (
    <section
      id="pillars"
      className="relative overflow-hidden bg-[#FAF7F2] py-16 md:py-20"
    >
      {/* Abstract animated eclipse background */}
      <EclipseBackground />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-10 text-center md:mb-12">
          {/* <motion.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-3 inline-block rounded-full border border-[#DA2128]/20 bg-[#DA2128]/5 px-4 py-1 text-[10px] font-bold tracking-[0.25em] text-[#DA2128] uppercase backdrop-blur-sm"
          >
            Viksit Bharat 2047
          </motion.span> */}
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="font-serif text-4xl font-medium leading-tight tracking-tight sm:text-3xl lg:text-4xl"
          >
            Growth {" "}
            <motion.span 
                className="italic text-[#DA2128]"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
            Pillars
            </motion.span>
          </motion.h2>
          <motion.div
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3, duration: 0.5 }}
            className="mx-auto mt-3 h-1 w-16 rounded-full bg-gradient-to-r from-[#DA2128] to-amber-500"
          />
          <motion.p
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.15 }}
            className="mx-auto mt-4 max-w-3xl text-sm leading-relaxed text-gray-600 sm:text-[15px]"
          >
            The engagements at ASSOCHAM, India's Apex Chamber of Commerce, are
            driven by its five growth pillars, aligned with the Hon'ble Prime
            Minister's vision of Viksit Bharat 2047. These pillars are focused
            on building a self-reliant, business-competitive, digitally
            empowered, and developed Indian economy.
          </motion.p>
        </div>

        {/* Pillar cards — zig-zag */}
        <div className="space-y-3 sm:space-y-4">
          {pillars.map((pillar, i) => {
            const isEven = i % 2 === 0;

            return (
              <motion.div
                key={pillar.number}
                initial={{
                  opacity: 0,
                  x: isEven ? -60 : 60,
                  y: 20,
                }}
                whileInView={{
                  opacity: 1,
                  x: 0,
                  y: 0,
                }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{
                  duration: 0.65,
                  delay: i * 0.08,
                  ease: [0.22, 1, 0.36, 1],
                }}
                className="group relative grid overflow-hidden rounded-2xl bg-white/80 shadow-md shadow-black/5 backdrop-blur-sm transition-all duration-500 hover:shadow-xl hover:shadow-black/10 md:grid-cols-2"
              >
                {/* IMAGE side */}
                <div
                  className={`relative h-24 overflow-hidden sm:h-28 md:min-h-[220px] ${
                    !isEven ? "md:order-2" : ""
                  }`}
                >
                  <motion.img
                    initial={{ scale: 1.15 }}
                    whileInView={{ scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1.2, ease: "easeOut" }}
                    src={pillar.image}
                    alt={pillar.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div
                    className={`absolute inset-0 ${
                      isEven
                        ? "bg-gradient-to-t from-black/50 via-black/10 to-transparent md:bg-gradient-to-r md:from-black/20 md:via-transparent md:to-transparent"
                        : "bg-gradient-to-t from-black/50 via-black/10 to-transparent md:bg-gradient-to-l md:from-black/20 md:via-transparent md:to-transparent"
                    }`}
                  />

                </div>

                {/* CONTENT side */}
                <div
                  className={`relative flex flex-col justify-center p-3 sm:p-4 md:p-4 lg:p-5 ${
                    !isEven ? "md:order-1 md:text-right" : ""
                  }`}
                >
                  <div
                    className={`flex items-start gap-3 ${
                      !isEven ? "md:flex-row-reverse md:text-right" : ""
                    }`}
                  >
                    {/* Icon */}
                    <motion.div
                      initial={{ scale: 0, rotate: -15 }}
                      whileInView={{ scale: 1, rotate: 0 }}
                      viewport={{ once: true }}
                      transition={{
                        duration: 0.5,
                        delay: i * 0.08 + 0.2,
                        type: "spring",
                        bounce: 0.6,
                      }}
                      className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#DA2128]/10 text-[#DA2128] transition-all duration-300 group-hover:bg-[#DA2128] group-hover:text-white group-hover:scale-110 group-hover:rotate-6 sm:h-10 sm:w-10"
                    >
                      <pillar.icon size={18} strokeWidth={2.2} />
                    </motion.div>

                    <div className="flex-1 min-w-0">
                      <h3 className="text-base font-bold leading-tight text-gray-900 sm:text-lg">
                        {pillar.title}
                      </h3>
                      <p className="mt-0.5 text-[11px] font-semibold text-[#DA2128] sm:text-xs">
                        {pillar.subtitle}
                      </p>
                      <p className="mt-1.5 text-xs leading-relaxed text-gray-600 sm:text-[13px]">
                        {pillar.desc}
                      </p>

                      {/* small divider */}
                      <div
                        className={`mt-2.5 h-[2px] w-8 rounded-full bg-[#DA2128] ${
                          !isEven ? "md:ml-auto" : ""
                        }`}
                      />
                    </div>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
